import { HTMLAttributes, ReactNode } from 'react'

import { cn } from '@shared/lib/cn'

import styles from './styles.module.scss'



interface SpaceProps extends HTMLAttributes<HTMLDivElement> {
  className?: string;
  children: ReactNode;
}

export default function Space (props: SpaceProps) {
  const { className, children } = props

  return <div className={cn(styles.root, className)}>{children}</div>
}
